package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.db.ErrorTypeData
import com.neurobs.js.controller.{AdminListAdapter, AdminListController, AdminPanelDelegate}
import com.neurobs.js.dom.RecordTableView
import com.neurobs.js.view.Gui
import com.neurobs.js.util.StringUtilities.dateString

import scala.concurrent.Future
import scala.concurrent.ExecutionContext.Implicits.global

class ErrorTypeListController(gui: Gui, cache: RecordCache) extends AdminListAdapter[ErrorTypeData] {

	override def title: String = "Error Types"

	override def itemName: String = "Error Type"

	override def columnHeaders: Seq[RecordTableView.ColumnHeader] = Seq(
		"DID",
		"Created",
		"Identifier",
		"Description"
	)

	override def itemRow(a: ErrorTypeData, delegate: Option[AdminPanelDelegate], controller: AdminListController[ErrorTypeData]): Seq[RecordTableView.CellContent] = Seq(
		a.id.toString,
		dateString(a.createdAt),
		a.identifier,
		a.description
	)

	override val create: Option[AdminListController[ErrorTypeData] => Unit] = None

	override def get(): Future[Either[String, Seq[ErrorTypeData]]] = {
		cache.errorTypes.clear()
		cache.errorTypes.get map {
			case Left(error) => Left(error.description)
			case Right(data) => Right(data)
		}
	}
}

object ErrorTypeListController {
	def apply(gui: Gui, cache: RecordCache): AdminListController[ErrorTypeData] = new AdminListController[ErrorTypeData](new ErrorTypeListController(gui, cache))
}
